// constants.js for ShopConfig feature (private)
// All static data, magic numbers, and configuration for ShopConfig
import * as Yup from 'yup';
import { SHOP_TYPES as SHOP_TYPES_FROM_CONSTANTS } from '../../../constants/shopTypes';

export const SHOP_TYPES = SHOP_TYPES_FROM_CONSTANTS;
export const DAYS_OF_WEEK = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' }
];

export const SOCIAL_MEDIA_OPTIONS = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'TikTok', value: 'tiktok' },
];

export const getPaymentMethods = (shopType) => {
  const baseMethods = [
    { label: 'Cash', value: 'cash', requiresInput: false },
    { label: 'GCash', value: 'gcash', requiresInput: true },
    { label: 'Maya', value: 'maya', requiresInput: true },
    { label: 'Bank Transfer', value: 'bank', requiresInput: false },
    { label: 'Credit Card', value: 'credit_card', requiresInput: false }
  ];

  if (shopType === 'FB_restaurant' || shopType === 'RT_clothing') {
    baseMethods.push({ label: 'Cash on Delivery', value: 'cod', requiresInput: false });
  }

  return baseMethods;
};


export const VALIDATION_SCHEMA = Yup.object().shape({
  shopName: Yup.string().required('Business name is required'),
  shopType: Yup.array().min(1, 'At least one category is required'),
  storeAddress: Yup.string().required('Location is required'),
  directions: Yup.string().required('Directions is required'),
  markerPosition: Yup.object().required('Please select your location on the map'),
});